import React from "react";

const EmailSending = () => {
  return (
    <div>
      <h5>Email Sending...</h5>
    </div>
  );
};

export default EmailSending;
